import { generateTypes } from '../utils/HttpReducerHelper';

export * from './reportEntities/types';

export const teamUserReports = generateTypes('USER_REPORT', 'TEAM_USER_REPORTS');
